import script from "./ClubPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubPolicy.vue?vue&type=script&setup=true&lang=js"

import "./ClubPolicy.vue?vue&type=style&index=0&id=670d569c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-670d569c"]])

export default __exports__